// {{ $t('立即添加') }}
// $t('立即添加')
// this.$t('立即添加')

export default {
  保存: 'Save',
  请输入链接: 'Please enter the link',
  添加联系人: 'Add contact',
  设为云展系统3D封面: 'Set as cloud exhibition 3D cover',
  建议比例: 'Recommended ratio',
  剩余可添加数据量: 'Remaining addable data volume',
  张: '',
  最多上传: 'Maximum upload',
  添加图片: 'Add image',
  招标行业: 'Industry',
  招标公告: 'Announcement',
  立即参展: 'Register for the exhibition',
  我的: 'My',
  立即添加: 'Add',
  上传视频: 'Upload a video',
  添加企业漫游提示2:
    'Cloud Momentum is offered in two languages (Chinese/English) for users from home and abroad. Please select the language version and edit the info.',
  完成: 'Done',
  显示: 'Show',
  隐藏: 'Hide',
  确定要显示吗: 'Show the 3D display',
  确定要隐藏吗: 'Hide the 3D display',
  标题链接: 'Title/Link',
  封面: 'Cover',
  公开展示: 'Visible to the public',
  添加企业漫游提示1: 'To add or edit a 3D display requires manual review',
  刷新: 'Refresh',
  拖动排序按钮可以调整展示顺序: 'Change the order by dragging the sort button',
  管理云企业: 'Manage the 3D display',
  暂无云视频: 'No video',
  暂无云企业: 'No 3D display',
  添加企业漫游: 'Add 3D displays',
  提交审核成功: 'Successfully submitted',
  展示内容设置: 'Manage the navigation',
  管理: 'manage',
  已收藏: 'collected',
  推荐: 'recommend',
  收起: 'pick up',
  展开: 'unfold',
  暂无: 'no',
  工商信息: 'Business Information',
  企业信息编辑: 'Corporate Information Edit',
  详细地址: 'Address',
  上市代码: 'Listing code',
  交易机构: 'Trading agency',
  国家: 'country',
  企业员工数量: 'Number of employees',
  长度超出最大限制: 'Length exceeds the maximum limit',
  不能为空: 'Can not be empty',
  ch_提示3: 'The recommended ratio of image upload is 1:1, and the size limit is within 2M',
  ch_提示2:
    'The information requires manual review, and will be updated with the latest information after the review is passed',
  ch_提示1:
    'In order to facilitate domestic and foreign customers to browse the cloud exhibition system, we have two different versions of the language content, please select the language content version you want to edit.',
  企业联系信息编辑: 'Corporate Contact Information Edit',
  请选择您要编辑的语言版本: 'Please select the language version you want to edit',
  国际版内容: 'English version content',
  中文版内容: 'Chinese content',
  导航: 'Navigation',

  ch_联系我们: 'Contact Info',
  ch_云同事: 'Employees',
  ch_云伙伴: 'Partners',
  ch_云荣誉: 'Achievements',
  ch_云相册: 'Photos',
  ch_对外投资: 'Investees',
  ch_投资机构: 'Investors',
  ch_云招标: 'Tenders',
  ch_云采购: 'Sourcing',
  ch_云动态: 'News',
  ch_云头条: 'Headlines',
  ch_云直播: 'Live Stream',
  ch_云招商: 'merchants',
  ch_云优惠: 'Offers',
  ch_云会议: 'Conferences',
  ch_云展览: 'Exhibitions',
  ch_云产品: 'Products',
  ch_云视频: 'Videos',
  ch_云企业: 'Enterprises',
}
